import {Component, Input, OnInit} from '@angular/core';
import {PricingModel, SubscriptionPricingModel} from '../../../../models/localization-and-pricing/pricing.model';
import {BookVersionModel} from '../../../../models/edu-admin/book-version.model';
import {ShippingInfoModel} from '../shipping-info/shipping-info.component';
import {UserModel} from '../../../../models/authentication/user.model';
import {CountryModel} from '../../../../models/localization-and-pricing/country.model';
import {DateHelper} from '../../../../models/extensions/date-helper';
import {DateTime} from 'luxon';

@Component({
  selector: 'app-billing-details',
  templateUrl: './billing-details.component.html',
  styleUrls: ['./billing-details.component.css']
})
export class BillingDetailsComponent implements OnInit {

  /**
   * The subscription pricing which lets us know which subscription we
   * are working with and its pricing.
   */
  @Input() subscription: SubscriptionPricingModel;

  /**
   * The length and type of subscription, can be trial, 1M, 3M, 6M
   * and 12M. Used to determine contract length and display correct
   * information to the user.
   */
  @Input() subscriptionType: string;

  /**
   * The book version the user has ordered when applicable. Currently
   * only supported in Iceland as part of the subscription.
   */
  @Input() bookVersion: BookVersionModel;

  /**
   * We need to know which shipping was selected. This will be country
   * dependent and will need to be outsourced to a component to handle.
   */
  @Input() shippingInfo: ShippingInfoModel;

  constructor() { }

  ngOnInit() {
  }

  getShippingPrice(): string {

    if (UserModel.getCurrent().country === CountryModel.ISL) {

      if (this.shippingInfo && this.shippingInfo.location) {

        const price = this.shippingInfo.location.price.toString(10);

        return `${price} kr.`;

      } else {
        /**
         * TODO: Select location
         */
        return '0 kr.';
      }

    } else if (this.subscription.includesBook) {

      return this.subscription.getShippingWithCurrencySymbol();

    }

    return null;

  }

  getShippingInfo(): string {

    if (UserModel.getCurrent().country === CountryModel.ISL) {

      if (this.shippingInfo && this.shippingInfo.location) {

        const name = this.shippingInfo.location.name;
        const address = this.shippingInfo.location.address;

        return `${name}, ${address}`;

      } else {
        /**
         * TODO: Translation for select location
         */
        return 'Input your shipping information to select a shipping method.';
      }

    }

    return '';
  }

  getTotalPrice(): string {

    if (UserModel.getCurrent().country === CountryModel.ISL) {

      if (this.shippingInfo && this.shippingInfo.location) {

        const shippingPrice = this.shippingInfo.location.price;
        const subPrice = parseInt(this.subscription.userVisiblePrice.replace('.', ''), 10);

        return (shippingPrice + subPrice).toString() + ' kr.';

      }

    }

    return this.subscription.userVisiblePriceWithCurrencySymbol();

  }

  getSubscriptionTitle(): string {

    if (this.subscriptionType === 'trial') {
      return 'lp2.pricing.Subscriptions.freeTrial.title';
    } else if (this.subscriptionType === PricingModel.SubscriptionTypes['6M']) {
      return 'lp2.pricing.Subscriptions.6m.title';
    } else if (this.subscriptionType === PricingModel.SubscriptionTypes['3M']) {
      return 'lp2.pricing.Subscriptions.3m.title';
    } else if (this.subscriptionType === PricingModel.SubscriptionTypes['1M']) {
      return 'lp2.pricing.Subscriptions.1m.title';
    }

    return 'lp2.pricing.Subscriptions.12m.title';
  }

  nextRenewalDate(): DateTime {

    const months = parseInt(this.subscription.repeatInterval, 10);

    const currentDate = DateTime.fromJSDate(new Date());
    const nextDate = currentDate.plus({ months: months });

    return nextDate;

  }

  nextRenewalString(): string {

    return this.nextRenewalDate().toLocaleString(DateTime.DATE_SHORT);
  }

  renewalPriceString(): string {

    return this.subscription.userVisiblePriceWithCurrencySymbol();
  }

}
